// @flow

import * as React from 'react';

import { Base } from '@gandi/ui';

import styles from './LabelContent.scss';

type Props = {
  label: string,
  htmlFor?: string,
  children: React.Node,
};

export default function LabelContent({
  label,
  htmlFor,
  children,
}: Props): React.MixedElement {
  const tag = htmlFor ? 'label' : 'span';

  return (
    <Base
      tagName="span"
      flex
      flexColToRow
      className={styles.inputWithLabel}
      gap="xsmall"
    >
      <Base htmlFor={htmlFor} tagName={tag} className={styles.rowLabel}>
        {label}
      </Base>
      {children}
    </Base>
  );
}
